/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';

/**
 * 
 * @export
 * @interface CampaignLinkDto
 */
export interface CampaignLinkDto {
    /**
     * 
     * @type {string}
     * @memberof CampaignLinkDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignLinkDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignLinkDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignLinkDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CampaignLinkDto
     */
    validFrom: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CampaignLinkDto
     */
    validTo: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignLinkDto
     */
    affiliateCode: string | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignLinkDto
     */
    trialDays: number | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignLinkDto
     */
    couponId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignLinkDto
     */
    firstPurchaseOnly: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CampaignLinkDto
     */
    allowPaymentWithoutCreditCard: boolean;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof CampaignLinkDto
     */
    preferredLookupKey: LookupKeyEnum | null;
    /**
     * 
     * @type {Array<LookupKeyEnum>}
     * @memberof CampaignLinkDto
     */
    allowedLookupKeys: Array<LookupKeyEnum>;
}

export function CampaignLinkDtoFromJSON(json: any): CampaignLinkDto {
    return CampaignLinkDtoFromJSONTyped(json, false);
}

export function CampaignLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CampaignLinkDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'slug': json['slug'],
        'name': json['name'],
        'isActive': json['isActive'],
        'validFrom': (json['validFrom'] === null ? null : new Date(json['validFrom'])),
        'validTo': (json['validTo'] === null ? null : new Date(json['validTo'])),
        'affiliateCode': json['affiliateCode'],
        'trialDays': json['trialDays'],
        'couponId': json['couponId'],
        'firstPurchaseOnly': json['firstPurchaseOnly'],
        'allowPaymentWithoutCreditCard': json['allowPaymentWithoutCreditCard'],
        'preferredLookupKey': LookupKeyEnumFromJSON(json['preferredLookupKey']),
        'allowedLookupKeys': ((json['allowedLookupKeys'] as Array<any>).map(LookupKeyEnumFromJSON)),
    };
}

export function CampaignLinkDtoToJSON(value?: CampaignLinkDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'slug': value.slug,
        'name': value.name,
        'isActive': value.isActive,
        'validFrom': (value.validFrom === null ? null : value.validFrom.toISOString()),
        'validTo': (value.validTo === null ? null : value.validTo.toISOString()),
        'affiliateCode': value.affiliateCode,
        'trialDays': value.trialDays,
        'couponId': value.couponId,
        'firstPurchaseOnly': value.firstPurchaseOnly,
        'allowPaymentWithoutCreditCard': value.allowPaymentWithoutCreditCard,
        'preferredLookupKey': LookupKeyEnumToJSON(value.preferredLookupKey),
        'allowedLookupKeys': ((value.allowedLookupKeys as Array<any>).map(LookupKeyEnumToJSON)),
    };
}

